/** Whether or not touch gestures are supported by the browser. */
export var touch = 'ontouchstart' in window ||
    (navigator.msMaxTouchPoints ? true : false) ||
    false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/_modules/support.js
// module id = 130
// module chunks = 0